import React from 'react';
import { VersionType } from '@Shared.Angular/interfaces/version-type.enum';

type VersionBadgeProps = {
  status: VersionType;
  versionNumber?: string | number;
};

export const VersionBadge = ({ status, versionNumber }: VersionBadgeProps) => {
  const renderContent = (): React.ReactNode => {
    switch (status) {
      case VersionType.Published:
        return versionNumber !== undefined && versionNumber !== null
          ? `V${versionNumber}`
          : null;
      case VersionType.Saved:
        return <i className="fa fa-bookmark" />;
      case VersionType.AutoSaved:
        return <i className="fa fa-angle-down" />;
      default:
        return null;
    }
  };

  return (
    <div
      className={`version-badge version-badge--${status.toLowerCase()}`}
      data-testid={`version-badge-${status.toLowerCase()}`}
    >
      {renderContent()}
    </div>
  );
};
